import { inject, injectable } from 'inversify';
import format from 'date-fns/format';
import Request from '@/Framework/api/Rpc/Request';
import SocketDispatcher from '@/finsight/application/DI/Rpc/finsight-web/SocketDispatcher';
import base from '@/Framework/url/baseUrl';
import getUTCDate from '@/Framework/dateHelpers/getUTCDate';

const DATE_FORMAT_COOKIE = "EEEE, dd-MMM-yyyy HH:mm:ss 'UTC'";

@injectable()
class AnalyticsTrackRepository {
  constructor(
    @inject(SocketDispatcher) protected readonly socketRpc: typeof SocketDispatcher,
  ) {}

  track = async (subjectKey: string, payload: {} = {}, headers: {} = {}, isBeacon: boolean = false) => {
    const occurredAt = format(getUTCDate(), DATE_FORMAT_COOKIE);
    let request = new Request('analytics.track', {
      subjectKey,
      ...payload,
      occurredAt,
    }, headers);

    if (isBeacon) {
      navigator.sendBeacon(base.getRpcUrl(), JSON.stringify(request));
      return Promise.resolve();
    }

    return this.socketRpc.call(request);
  };
}

export default AnalyticsTrackRepository;
